import { ofType } from "redux-observable";
import { from } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { selectPackageGoldCost } from "../../../balancingSelectors/selectBalancingPackages";
import { IdResource } from "../../../constants/IdResource";
import { selectPlayerInfo } from "../../../selectors/selectPlayerInfo";
import { selectTraderEventDetails } from "../../../selectors/selectTraderEventInfo";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionInventoryInfoRemoveResource } from "../../info/inventory/actionInventoryInfo";
import { actionPurchasePackageInfoPurchased } from "../../info/purchase-packages/actionSetPurchasePackageInfo";
import { actionConsumePackage, } from "../../item-packages/actionPackages";
import { actionTraderEventRequest, TypeActionTraderEventInfo } from "../actionTraderEventInfo";
export var epicTraderEventsBuyPackageRequest = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionTraderEventInfo.RequestBuyPackage), switchMap(function (action) {
        var state = state$.value;
        var playerId = selectPlayerInfo(state).playerId;
        var packageId = action.packageId;
        var eventId = selectTraderEventDetails(state)[0].eventId;
        return deps
            .netSend({
            id: CommandCode.BuyPackage,
            props: {
                amount: 1,
                eventId: eventId,
                packageId: packageId,
                playerId: playerId,
            },
        })
            .pipe(retry(), switchMap(function (res) {
            var cost = selectPackageGoldCost(packageId);
            var goldCost = { amount: cost, typeId: IdResource.Gold };
            return from([
                actionConsumePackage(packageId),
                actionInventoryInfoRemoveResource([goldCost]),
                actionPurchasePackageInfoPurchased(packageId),
                actionTraderEventRequest(),
            ]);
        }));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/trader-event/epics/epicTraderEventsBuyPackageRequest.ts
// module id = 2458
// module chunks = 3